import React, { useEffect, useState } from 'react'
import Footer from '../components/Footer'
import Grid from '@mui/material/Grid';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import EmployeesBox from '../components/EmployeesBox';
import Welcome from '../components/Welcome';
import PinAuth from '../components/PinAuth';
import { isUserIdKioskAuthMode } from '../utils/kioskAuthMode';
import './Main.css';

function Main() {
  const [employee, setEmployee] = useState(null);
  const [employeeResetSignal, setEmployeeResetSignal] = useState(0);


  const navigate = useHistory();
  const userLogin = useSelector((state) => state.userLogin);
  const { companyInfo } = userLogin;
  const isUserIdEmployeeLogin = isUserIdKioskAuthMode(companyInfo?.kioskAuthMode);
  const userIdEmployee = employee || { kioskUserId: "", loginMode: "userId" };
  const contentContainerStyle = {
    padding: "10px",
    marginTop: "5rem",
    ...(isUserIdEmployeeLogin
      ? {}
      : {
          flexWrap: "nowrap",
          minHeight: "calc(100vh - 9rem)",
          overflow: "hidden",
          paddingBottom: "1rem",
        }),
  };

  const employeeInfo = (sessionStorage.getItem("employeeInfo") !== null) ? JSON.parse(sessionStorage.getItem("employeeInfo")) : null;
  useEffect(() => {
    if (employeeInfo !== null) {
      navigate.push(`/dashboard/${employeeInfo.data.employee.id}`);
    }
  }, [employeeInfo, navigate]);

  useEffect(() => {
    if (!employee) {
      return;
    }

    let inactivityTimer = null;

    const resetTimer = () => {
      if (inactivityTimer) {
        clearTimeout(inactivityTimer);
      }
      inactivityTimer = setTimeout(() => {
        setEmployee(null);
        setEmployeeResetSignal((prev) => prev + 1);
      }, 30000);
    };

    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];
    events.forEach((eventName) => window.addEventListener(eventName, resetTimer));
    resetTimer();

    return () => {
      if (inactivityTimer) {
        clearTimeout(inactivityTimer);
      }
      events.forEach((eventName) => window.removeEventListener(eventName, resetTimer));
    };
  }, [employee]);
  
  return (
    <div>
      <div className="main-screen-bg">
      </div>
      <div className="main-screen">
        <Grid
          container
          style={contentContainerStyle}
          justifyContent={isUserIdEmployeeLogin ? "center" : "flex-start"}
        >
          {isUserIdEmployeeLogin ? (
            <Grid item xs={12} md={8} lg={6}>
              <EmployeesBox
                className="employee-box"
                handleEmployee={setEmployee}
                resetSignal={employeeResetSignal}
                singleCard
                headerContent={<Welcome mode="userId" compact />}
                footerContent={<PinAuth employee={userIdEmployee} embedded />}
              />
            </Grid>
          ) : (
            <>
              <Grid item style={{ flex: "0 0 40%", maxWidth: "40%" }}>
                <EmployeesBox
                  className="employee-box"
                  handleEmployee={setEmployee}
                  resetSignal={employeeResetSignal}
                />
              </Grid>
              <Grid item style={{ flex: "0 0 60%", maxWidth: "60%" }}>
                {employee ? (
                  <PinAuth employee={employee} />
                ) : (
                  <Welcome mode="list" />
                )}
              </Grid>
            </>
          )}
        </Grid>
      </div>
      <Footer />
    </div>

  )
}

export default Main;